export default __webpack_public_path__ + "static/media/business.a7f2eb12.svg";